// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-end {
  border-end-end-radius: 50px;
  border-start-end-radius: 50px;
}

.button-start {
  border-end-start-radius: 3rem;
  border-start-start-radius: 3rem;
}

.icon2 {
  width: 1rem;
}

.game-bar {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 2;
  min-width: 20rem;
  height: 2.5rem;
  background: var(--color-light-blue);
  border-radius: 5rem;
}
.game-bar .btn-group {
  background: var(--color-light-blue);
  width: 100%;
  border: none;
  color: var(--color-primary-blue);
  height: 2.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
}

.flex-container {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.flex-container .gm-flex-col {
  flex: auto;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  position: relative;
}
.flex-container .gm-flex-col .gm-flex-75 {
  flex: 75%;
}
.flex-container .gm-flex-col .gm-flex-50 {
  flex: 50%;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .gm-flex-25 {
  flex: 25%;
}
.flex-container .gm-flex-col .iconBold {
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconHand {
  margin: 0;
  width: 1.542rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconStar {
  width: 1.208rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconFlag {
  width: 1.333rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .icon {
  width: 1rem;
}
.flex-container .gm-flex-col .prev-action-points {
  position: absolute;
  right: 16%;
  font-size: 0.667rem;
  color: var(--color-white);
  display: none;
  background-color: var(--color-secondary-blue);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-alliance-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-white);
  display: none;
  background-color: var(--color-secondary-blue);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-council-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-primary-blue);
  display: none;
  background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-country-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-primary-blue);
  display: none;
  background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .fs-28 {
  font-size: 1.167rem;
}
.flex-container .gm-flex-col .fs-24 {
  font-size: 1rem;
}
.flex-container .gm-flex-col .fs-20 {
  font-size: 0.833rem;
}
.flex-container .gm-flex-col:not(:last-child) {
  border-right: 0.125rem solid rgba(51, 102, 153, 0.25);
}

.info {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 1;
  padding-right: 0.5rem;
  min-width: 7rem;
  height: 2.5rem;
  border-radius: 2rem;
  background: var(--color-light-blue);
}
.info .flex-container {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.info .icon-default {
  width: 1.2rem;
}
.info .icon-open {
  width: 2.2rem;
}
.info .text {
  font-size: 1rem;
  color: var(--color-primary-blue);
  font-weight: bold;
  line-height: 1.375rem;
}
.info .flex-col {
  display: flex;
  align-items: center;
}
.info .flex-col.flex-col-last {
  flex-grow: 1;
  padding-right: 0.5rem;
}
.info .book {
  padding: 0 0.6rem;
  background: white;
  cursor: pointer;
  border-radius: 4rem;
  min-width: 2rem;
}
.info .book.open {
  border-radius: 2rem 0 0 2rem;
  min-width: 2rem;
}
.info .flag-col {
  min-width: 2rem;
}
.info .flag-col.flag-solo {
  padding: 0 0.8rem;
}
.info .flag {
  height: 1rem;
  width: 1rem;
  box-shadow: 0 0.083rem 0 0 rgba(0, 0, 0, 0.24);
  border-radius: 50%;
}
.info .oval {
  position: absolute;
  bottom: -1.15rem;
  left: -0.8rem;
  z-index: 15;
  cursor: pointer;
}
.info .oval img {
  width: 4rem;
  height: 4rem;
}
.info .check-here {
  position: absolute;
  bottom: 4rem;
  left: -7rem;
  padding: 1rem;
}
.info .check-here .text {
  color: white;
  width: 10.708rem;
  font-size: 0.833rem;
  line-height: 1rem;
  text-align: center;
  font-weight: normal;
}
.info .check-here .white-arrow .white-arrow-icon {
  position: absolute;
  right: 7.5rem;
  width: 2rem;
  height: 3.333rem;
  --animate-duration: 1s;
}

ion-content {
  height: 100vh;
  --background: transparent;
  overflow-y: hidden;
}

:host ::ng-deep .info {
  z-index: 3 !important;
}

:host ::ng-deep .game-bar {
  z-index: 0 !important;
}

.eu-council-game-container {
  position: absolute;
  top: 0;
  z-index: 1;
  background-color: #183872;
}

.blur {
  width: 100%;
  height: 100%;
  opacity: 0.8;
  position: absolute;
  background-color: var(--color-primary-blue);
}

.container {
  position: relative;
  top: 0;
  z-index: 1;
  height: 100%;
  overflow: hidden;
}
.container .mid-row {
  height: 21rem;
  display: flex;
  align-content: flex-start;
}
.container .mid-row .inner-row {
  display: flex;
  justify-content: center;
  align-self: flex-start;
}
.container .mid-row .inner-row .box {
  width: 29rem;
  position: relative;
  display: inline-block;
  padding: 1.875rem 1.75rem 1.3rem 1.75rem;
  text-align: center;
  color: var(--color-white);
  margin-left: 5.333rem;
  border-radius: 11px;
  background: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0 1px, rgb(209, 213, 219) 0 0 0 1px inset;
  z-index: 5;
}
.container .mid-row .inner-row .box:before {
  content: "";
  position: absolute;
  border-left: 2px solid var(--color-white);
  border-bottom: 2px solid var(--color-white);
  left: 28.2rem;
  transform: rotateZ(45deg);
  width: 1rem;
  height: 1rem;
  top: 50%;
  background: var(--color-white);
  border-top: 0;
  border-right: 0;
}
.container .mid-row .inner-row .box .main-title {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 1.167rem;
  font-weight: bold;
  margin-bottom: 1.125rem;
}
.container .mid-row .inner-row .box .subtitle1 {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
}
.container .mid-row .inner-row .box .subtitle2 {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 1rem;
  font-weight: bold;
}
.container .mid-row .inner-row .box .page-2-subtitle {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 1rem;
  font-weight: 600;
}
.container .mid-row .inner-row .box .avatars {
  height: 7rem;
  width: auto;
}
.container .mid-row .inner-row .box .handshake {
  height: 4rem;
  width: auto;
}
.container .mid-row .inner-row .box .page-3-icons {
  margin-top: 1rem;
}
.container .mid-row .inner-row .box .page-3-icons .left-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container .mid-row .inner-row .box .page-3-icons .middle-col {
  margin-bottom: 1rem;
}
.container .mid-row .inner-row .box .page-3-icons .middle-col span {
  color: var(--color-primary-blue);
}
.container .mid-row .inner-row .box .page-3-icons .right-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container .mid-row .inner-row .box .page-3-icons .icon {
  height: 4.5rem;
  width: 4.5rem;
}
.container .mid-row .inner-row .box .btn-group {
  margin-top: 1rem;
}
.container .mid-row .inner-row .box .btn-group .buttonContinue {
  display: flex;
  justify-content: flex-end;
}
.container .mid-row .inner-row .box .btn-group .buttonContinue .button {
  --background: var(--color-primary-blue);
  font-size: 1rem;
  line-height: 1.167rem;
  min-width: 6.958rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
  font-weight: 600;
}
.container .mid-row .inner-row .box .btn-group .buttonSkip {
  display: flex;
  justify-content: flex-start;
}
.container .mid-row .inner-row .box .btn-group .buttonSkip .button {
  --background: var(--color-white);
  --border-color: var(--color-primary-blue);
  color: var(--color-primary-blue);
  font-size: 1rem;
  line-height: 1.125rem;
  min-width: 5.667rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
  font-weight: 600;
}
.container .mid-row .inner-row .box .btn-group .buttonNext {
  display: flex;
  justify-content: center;
}
.container .mid-row .inner-row .box .btn-group .buttonNext .button {
  --background: var(--color-primary-blue);
  font-size: 1rem;
  line-height: 1.167rem;
  min-width: 6.958rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
}
.container .mid-row .president {
  height: 23rem;
  display: grid;
  align-content: flex-start;
}
.container .mid-row .president .president-section {
  position: relative;
  height: 17rem;
}
.container .mid-row .president .president-section .president-image {
  position: absolute;
  top: 0;
  width: 10rem;
}
.container .mid-row .president .president-section .council {
  display: grid;
  position: absolute;
  margin-top: 0.3rem;
  padding: 0.6rem;
  color: var(--color-primary-blue);
  font-size: 0.917rem;
  text-align: center;
  line-height: 1rem;
  font-weight: bold;
  z-index: 5;
  bottom: 0;
}
.container .mid-row .president .president-section .council::after {
  content: "";
  background: url('tag.2c221075604cb8d6.svg') no-repeat center center/cover;
  width: 7.583rem;
  height: 3.083rem;
  margin-top: -2.5rem;
  z-index: -1;
}
.container .top-row {
  margin-top: 1.333rem;
  margin-bottom: 2.292rem;
}
.container .top-row .title {
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: bold;
  color: var(--color-white);
  text-shadow: 0 4px 0 rgba(0, 0, 0, 0.24);
}
.container .my-table {
  position: absolute;
  bottom: 0rem;
  right: 0rem;
  width: 81.542rem;
  height: 44.875rem;
  background-image: url('round-table.62c19d546e7a1d1e.svg');
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: 33rem 34rem;
  background-size: 75rem 41rem;
}

.text-title2 {
  color: #003399;
  letter-spacing: 0;
  line-height: 1.333rem;
  text-align: center;
  font-size: 1.167;
  margin-bottom: 0.8rem;
}

.text-title3 {
  color: #003399;
  letter-spacing: 0;
  line-height: 1.333rem;
  text-align: center;
  font-size: 1.167;
  margin-bottom: 0.8rem;
}

.text {
  margin-top: 0.5rem;
  padding-top: 0.6rem;
  padding: 0.6rem;
  font-size: 0.833rem;
  color: #003399;
  text-align: center;
  line-height: 1.333rem;
}

.text4 {
  padding-top: 0.2rem;
  font-size: 1rem;
  color: #003399;
  text-align: center;
  line-height: 1.333rem;
  font-weight: 600;
}

.group-txt {
  text-align: center;
}

.text5 {
  color: #003399;
  font-weight: 500;
  font-size: 1rem;
  line-height: 0.7rem;
}

.text2 {
  margin-top: 0.2rem;
  padding: 0.1rem;
  font-size: 0.833rem;
  color: #003399;
  text-align: center;
  line-height: 1.333rem;
}

.text3 {
  margin-top: 0.5rem;
  padding: 0.1rem;
  font-size: 0.833rem;
  color: #003399;
  text-align: center;
  line-height: 1.333rem;
}

.btn-group .button1 {
  background-color: #003399;
  border: none;
  color: white;
  padding: 0.7rem 1.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 0.5rem;
}

.button-end {
  border-end-end-radius: 3rem;
  border-start-end-radius: 3rem;
}

.button-start {
  border-end-start-radius: 3rem;
  border-start-start-radius: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/game-bar/game-bar.component.scss","webpack://./src/app/game/presentation-of-mission/presentation-of-mission.page.scss","webpack://./src/app/components/book-button/book-button.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,6BAAA;ACCF;;ADEA;EACE,6BAAA;EACA,+BAAA;ACCF;;ADEA;EACE,WAAA;ACCF;;ADEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,mBAAA;ACCF;ADCE;EACE,mCAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;ACCJ;;ADKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;ACFF;ADIE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;ACFJ;ADKI;EACE,SAAA;ACHN;ADMI;EACE,SAAA;EACA,aAAA;EACA,uBAAA;ACJN;ADOI;EACE,SAAA;ACLN;ADQI;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;ACNN;ADSI;EACE,SAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;ACPN;ADUI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;ACRN;ADWI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;ACTN;ADYI;EACE,WAAA;ACVN;ADaI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACXN;ADcI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACZN;ADeI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACbN;ADgBI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACdN;ADiBI;EACE,mBAAA;ACfN;ADkBI;EACE,eAAA;AChBN;ADmBI;EACE,mBAAA;ACjBN;ADqBE;EACE,qDAAA;ACnBJ;;ACvJA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mCAAA;AD0JF;ACxJE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AD0JJ;ACvJE;EACE,aAAA;ADyJJ;ACtJE;EACE,aAAA;ADwJJ;ACrJE;EACE,eAAA;EACA,gCAAA;EACA,iBAAA;EACA,qBAAA;ADuJJ;ACpJE;EACE,aAAA;EACA,mBAAA;ADsJJ;ACpJI;EACE,YAAA;EACA,qBAAA;ADsJN;AClJE;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EAEA,mBAAA;EACA,eAAA;ADmJJ;ACjJI;EACE,4BAAA;EACA,eAAA;ADmJN;AC/IE;EACE,eAAA;ADiJJ;AC/II;EACE,iBAAA;ADiJN;AC7IE;EACE,YAAA;EACA,WAAA;EACA,8CAAA;EACA,kBAAA;AD+IJ;AC5IE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AD8IJ;AC7II;EACE,WAAA;EACA,YAAA;AD+IN;AC3IE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AD6IJ;AC3II;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AD6IN;ACxIM;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AD0IR;;AAhPA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AAmPF;;AAhPA;EACE,qBAAA;AAmPF;;AAhPA;EACE,qBAAA;AAmPF;;AAhPA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,yBAAA;AAmPF;;AAhPA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;AAmPF;;AAhPA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAmPF;AAjPE;EACE,aAAA;EACA,aAAA;EACA,yBAAA;AAmPJ;AAjPI;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAmPN;AAjPM;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iFAAA;EAEA,UAAA;AAkPR;AAhPQ;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,2CAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;AAkPV;AA/OQ;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AAiPV;AA9OQ;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAgPV;AA7OQ;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AA+OV;AA5OQ;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AA8OV;AA3OQ;EACE,YAAA;EACA,WAAA;AA6OV;AA1OQ;EACE,YAAA;EACA,WAAA;AA4OV;AAzOQ;EACE,gBAAA;AA2OV;AAzOU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AA2OZ;AAxOU;EACE,mBAAA;AA0OZ;AAxOY;EACE,gCAAA;AA0Od;AAtOU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAwOZ;AArOU;EACE,cAAA;EACA,aAAA;AAuOZ;AAnOQ;EACE,gBAAA;AAqOV;AAnOU;EACE,aAAA;EACA,yBAAA;AAqOZ;AAnOY;EACE,uCAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAqOd;AAjOU;EACE,aAAA;EACA,2BAAA;AAmOZ;AAjOY;EACE,gCAAA;EACA,yCAAA;EACA,gCAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAmOd;AA/NU;EACE,aAAA;EACA,uBAAA;AAiOZ;AA/NY;EACE,uCAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAiOd;AA1NI;EACE,aAAA;EACA,aAAA;EACA,yBAAA;AA4NN;AA1NM;EACE,kBAAA;EACA,aAAA;AA4NR;AA1NQ;EACE,kBAAA;EACA,MAAA;EACA,YAAA;AA4NV;AAzNQ;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;AA2NV;AAxNQ;EACE,WAAA;EACA,yEAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AA0NV;AApNE;EACE,oBAAA;EACA,uBAAA;AAsNJ;AApNI;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,wCAAA;AAsNN;AAlNE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yDAAA;EACA,4BAAA;EACA,6BAAA;EAEA,gCAAA;EACA,4BAAA;AAmNJ;;AA/MA;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAkNF;;AA/MA;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAkNF;;AA/MA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAkNF;;AA/MA;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AAkNF;;AA/MA;EACE,kBAAA;AAkNF;;AA/MA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAkNF;;AA/MA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAkNF;;AA/MA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAkNF;;AA/MA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EAEA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAiNF;;AA9MA;EACE,2BAAA;EACA,6BAAA;AAiNF;;AA9MA;EACE,6BAAA;EACA,+BAAA;AAiNF","sourcesContent":[".button-end {\n  border-end-end-radius: 50px;\n  border-start-end-radius: 50px;\n}\n\n.button-start {\n  border-end-start-radius: 3rem;\n  border-start-start-radius: 3rem;\n}\n\n.icon2 {\n  width: 1rem;\n}\n\n.game-bar {\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  z-index: 2;\n  min-width: 20rem;\n  height: 2.5rem;\n  background: var(--color-light-blue);\n  border-radius: 5rem;\n\n  .btn-group {\n    background: var(--color-light-blue);\n    width: 100%;\n    border: none;\n    color: var(--color-primary-blue);\n    height: 2.5rem;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 1rem;\n    cursor: pointer;\n    padding: 0;\n  }\n}\n\n\n\n.flex-container {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n\n  .gm-flex-col {\n    flex: auto;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    padding-left: 0.3rem;\n    padding-right: 0.3rem;\n    position: relative;\n    //cursor: pointer;\n\n    .gm-flex-75 {\n      flex: 75%;\n    }\n\n    .gm-flex-50 {\n      flex: 50%;\n      display: flex;\n      justify-content: center;\n    }\n\n    .gm-flex-25 {\n      flex: 25%;\n    }\n\n    .iconBold {\n      margin-left: 0.5rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconHand {\n      margin: 0;\n      width: 1.542rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconStar {\n      width: 1.208rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconFlag {\n      width: 1.333rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .icon {\n      width: 1rem;\n    }\n\n    .prev-action-points {\n      position: absolute;\n      right: 16%;\n      font-size: 0.667rem;\n      color: var(--color-white);\n      display: none;\n      background-color: var(--color-secondary-blue);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-alliance-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-white);\n      display: none;\n      background-color: var(--color-secondary-blue);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-council-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-primary-blue);\n      display: none;\n      background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-country-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-primary-blue);\n      display: none;\n      background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .fs-28 {\n      font-size: 1.167rem;\n    }\n  \n    .fs-24 {\n      font-size: 1rem;\n    }\n\n    .fs-20 {\n      font-size: 0.833rem;\n    }\n  }\n\n  .gm-flex-col:not(:last-child) {\n    border-right: 0.125rem solid rgba(51, 102, 153, 0.25);\n  }\n}\n","@import \"./../game-bar/game-bar.component.scss\";\n@import \"./../../components/book-button/book-button.component.scss\";\n\nion-content {\n  height: 100vh;\n  --background: transparent;\n  overflow-y: hidden;\n}\n\n:host ::ng-deep .info {\n  z-index: 3 !important;\n}\n\n:host ::ng-deep .game-bar {\n  z-index: 0 !important;\n}\n\n.eu-council-game-container {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  background-color: #183872;\n}\n\n.blur {\n  width: 100%;\n  height: 100%;\n  opacity: 0.8;\n  position: absolute;\n  background-color: var(--color-primary-blue);\n}\n\n.container {\n  position: relative;\n  top: 0;\n  z-index: 1;\n  height: 100%;\n  overflow: hidden;\n\n  .mid-row {\n    height: 21rem;\n    display: flex;\n    align-content: flex-start;\n\n    .inner-row {\n      display: flex;\n      justify-content: center;\n      align-self: flex-start;\n\n      .box {\n        width: 29rem;\n        position: relative;\n        display: inline-block;\n        padding: 1.875rem 1.75rem 1.3rem 1.75rem;\n        text-align: center;\n        color: var(--color-white);\n        margin-left: 5.333rem;\n        border-radius: 11px;\n        background: var(--color-white);\n        box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0 1px,\n          rgb(209, 213, 219) 0 0 0 1px inset;\n        z-index: 5;\n\n        &:before {\n          content: \"\";\n          position: absolute;\n          border-left: 2px solid var(--color-white);\n          border-bottom: 2px solid var(--color-white);\n          left: calc(28.7rem - 0.5rem);\n          transform: rotateZ(45deg);\n          width: 1rem;\n          height: 1rem;\n          top: 50%;\n          background: var(--color-white);\n          border-top: 0;\n          border-right: 0;\n        }\n\n        .main-title {\n          color: var(--color-primary-blue);\n          letter-spacing: 0;\n          line-height: 1.333rem;\n          font-size: 1.167rem;\n          font-weight: bold;\n          margin-bottom: 1.125rem;\n        }\n\n        .subtitle1 {\n          color: var(--color-primary-blue);\n          letter-spacing: 0;\n          line-height: 1.333rem;\n          font-size: 1rem;\n          margin-bottom: 1rem;\n          font-weight: bold;\n        }\n\n        .subtitle2 {\n          color: var(--color-primary-blue);\n          letter-spacing: 0;\n          line-height: 1.333rem;\n          font-size: 1rem;\n          font-weight: bold;\n        }\n\n        .page-2-subtitle {\n          color: var(--color-primary-blue);\n          letter-spacing: 0;\n          line-height: 1.333rem;\n          font-size: 1rem;\n          font-weight: 600;\n        }\n\n        .avatars {\n          height: 7rem;\n          width: auto;\n        }\n\n        .handshake {\n          height: 4rem;\n          width: auto;\n        }\n\n        .page-3-icons {\n          margin-top: 1rem;\n\n          .left-col {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n          }\n\n          .middle-col {\n            margin-bottom: 1rem;\n\n            span {\n              color: var(--color-primary-blue);\n            }\n          }\n\n          .right-col {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n          }\n\n          .icon {\n            height: 4.5rem;\n            width: 4.5rem;\n          }\n        }\n\n        .btn-group {\n          margin-top: 1rem;\n\n          .buttonContinue {\n            display: flex;\n            justify-content: flex-end;\n\n            .button {\n              --background: var(--color-primary-blue);\n              font-size: 1rem;\n              line-height: 1.167rem;\n              min-width: 6.958rem;\n              height: 2rem;\n              min-height: 2rem;\n              --min-height: 2rem;\n              font-weight: 600;\n            }\n          }\n\n          .buttonSkip {\n            display: flex;\n            justify-content: flex-start;\n\n            .button {\n              --background: var(--color-white);\n              --border-color: var(--color-primary-blue);\n              color: var(--color-primary-blue);\n              font-size: 1rem;\n              line-height: 1.125rem;\n              min-width: 5.667rem;\n              height: 2rem;\n              min-height: 2rem;\n              --min-height: 2rem;\n              font-weight: 600;\n            }\n          }\n\n          .buttonNext {\n            display: flex;\n            justify-content: center;\n\n            .button {\n              --background: var(--color-primary-blue);\n              font-size: 1rem;\n              line-height: 1.167rem;\n              min-width: 6.958rem;\n              height: 2rem;\n              min-height: 2rem;\n              --min-height: 2rem;\n            }\n          }\n        }\n      }\n    }\n\n    .president {\n      height: 23rem;\n      display: grid;\n      align-content: flex-start;\n\n      .president-section {\n        position: relative;\n        height: 17rem;\n\n        .president-image {\n          position: absolute;\n          top: 0;\n          width: 10rem;\n        }\n\n        .council {\n          display: grid;\n          position: absolute;\n          margin-top: 0.3rem;\n          padding: 0.6rem;\n          color: var(--color-primary-blue);\n          font-size: 0.917rem;\n          text-align: center;\n          line-height: 1rem;\n          font-weight: bold;\n          z-index: 5;\n          bottom: 0;\n        }\n\n        .council::after {\n          content: \"\";\n          background: url(../../../assets/tag.svg) no-repeat center center/cover;\n          width: 7.583rem;\n          height: 3.083rem;\n          margin-top: -2.5rem;\n          z-index: -1;\n        }\n      }\n    }\n  }\n\n  .top-row {\n    margin-top: 1.333rem;\n    margin-bottom: 2.292rem;\n\n    .title {\n      font-size: 1rem;\n      line-height: 1.375rem;\n      font-weight: bold;\n      color: var(--color-white);\n      text-shadow: 0 4px 0 rgba(0, 0, 0, 0.24);\n    }\n  }\n\n  .my-table {\n    position: absolute;\n    bottom: 0rem;\n    right: 0rem;\n    width: 81.542rem;\n    height: 44.875rem;\n    background-image: url(\"../../../assets/round-table.svg\");\n    background-repeat: no-repeat;\n    background-attachment: scroll;\n    //background-position: 14rem 21rem;\n    background-position: 33rem 34rem;\n    background-size: 75rem 41rem;\n  }\n}\n\n.text-title2 {\n  color: #003399;\n  letter-spacing: 0;\n  line-height: 1.333rem;\n  text-align: center;\n  font-size: 1.167;\n  margin-bottom: 0.8rem;\n}\n\n.text-title3 {\n  color: #003399;\n  letter-spacing: 0;\n  line-height: 1.333rem;\n  text-align: center;\n  font-size: 1.167;\n  margin-bottom: 0.8rem;\n}\n\n.text {\n  margin-top: 0.5rem;\n  padding-top: 0.6rem;\n  padding: 0.6rem;\n  font-size: 0.833rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1.333rem;\n}\n\n.text4 {\n  padding-top: 0.2rem;\n  font-size: 1rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1.333rem;\n  font-weight: 600;\n}\n\n.group-txt {\n  text-align: center;\n}\n\n.text5 {\n  color: #003399;\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 0.7rem;\n}\n\n.text2 {\n  margin-top: 0.2rem;\n  padding: 0.1rem;\n  font-size: 0.833rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1.333rem;\n}\n\n.text3 {\n  margin-top: 0.5rem;\n  padding: 0.1rem;\n  font-size: 0.833rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1.333rem;\n}\n\n.btn-group .button1 {\n  background-color: #003399;\n  border: none;\n  color: white;\n  padding: 0.7rem 1.5rem;\n  // margin-left: 1.5rem;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 1rem;\n  cursor: pointer;\n  margin-top: 0.5rem;\n}\n\n.button-end {\n  border-end-end-radius: 3rem;\n  border-start-end-radius: 3rem;\n}\n\n.button-start {\n  border-end-start-radius: 3rem;\n  border-start-start-radius: 3rem;\n}\n",".info {\n  position: absolute;\n  bottom: 1rem;\n  right: 1rem;\n  z-index: 1;\n  padding-right: 0.5rem;\n  min-width: 7rem;\n  height: 2.5rem;\n  border-radius: 2rem;\n  background: var(--color-light-blue);\n\n  .flex-container {\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n  }\n\n  .icon-default {\n    width: 1.2rem;\n  }\n\n  .icon-open {\n    width: 2.2rem;\n  }\n\n  .text {\n    font-size: 1rem;\n    color: var(--color-primary-blue);\n    font-weight: bold;\n    line-height: 1.375rem;\n  }\n\n  .flex-col {\n    display: flex;\n    align-items: center;\n\n    &.flex-col-last {\n      flex-grow: 1;\n      padding-right: 0.5rem;\n    }\n  }\n\n  .book {\n    padding: 0 0.6rem;\n    background: white;\n    cursor: pointer;\n\n    border-radius: 4rem;\n    min-width: 2rem;\n\n    &.open {\n      border-radius: 2rem 0 0 2rem;\n      min-width: 2rem;\n    }\n  }\n\n  .flag-col {\n    min-width: 2rem;\n\n    &.flag-solo {\n      padding: 0 0.8rem;\n    }\n  }\n\n  .flag {\n    height: 1rem;\n    width: 1rem;\n    box-shadow: 0 0.083rem 0 0 rgba(0, 0, 0, 0.24);\n    border-radius: 50%;\n  }\n\n  .oval {\n    position: absolute;\n    bottom: -1.15rem;\n    left: -0.8rem;\n    z-index: 15;\n    cursor: pointer;\n    img {\n      width: 4rem;\n      height: 4rem;\n    }\n  }\n\n  .check-here {\n    position: absolute;\n    bottom: 4rem;\n    left: -7rem;\n    padding: 1rem;\n  \n    .text {\n      color: white;\n      width: 10.708rem;\n      font-size: 0.833rem;\n      line-height: 1rem;\n      text-align: center;\n      font-weight: normal;\n    }\n  \n    .white-arrow {\n  \n      .white-arrow-icon {\n        position: absolute;\n        right: 7.5rem;\n        width: 2rem;\n        height: 3.333rem;\n        --animate-duration: 1s;\n      }\n  \n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
